import P2Regular from 'components/typography/P2Regular';

/** Renders the human-readable hierarchy level without relationship icons. */
export default function DepartmentLevelColumn({ value }: { value?: string }) {
  return value ? <P2Regular>{value}</P2Regular> : null;
}
